import { createListenerMiddleware } from '@reduxjs/toolkit';
import { navigateTo } from '../../core/navigation/navigationSlice.js';
import { dynamicMiddleware } from '../../store/index.js';
const routes = {
    login: '/candidate/login',
    registration: '/candidate/register',
    registrationSuccess: '/candidate/register/success',
    resetPassword: '/candidate/password/reset',
    googleSuccess: '/candidate/google/success',
};
const getParams = () => {
    const queryString = window.location.href.split('?')[1];
    return queryString || '';
};
const getRoute = (routeName, currentLocale) => {
    return `/${currentLocale}${routes[routeName]}?${getParams()}`;
};
let pageNavigationMiddlewareInstance;
const pageNavigationMiddlewareOptions = {
    actionCreator: navigateTo,
    effect: async (action, listenerApi) => {
        listenerApi.cancelActiveListeners();
        const state = listenerApi.getState();
        window.location.assign(getRoute(action.payload, state.core.siteConfig.currentLocale));
    },
};
const addPageNavigationMiddleware = () => {
    dynamicMiddleware.resetMiddlewares();
    pageNavigationMiddlewareInstance = createListenerMiddleware();
    pageNavigationMiddlewareInstance.startListening(pageNavigationMiddlewareOptions);
    dynamicMiddleware.addMiddleware(pageNavigationMiddlewareInstance.middleware);
};
const pausePageNavigationMiddleware = () => {
    if (pageNavigationMiddlewareInstance) {
        pageNavigationMiddlewareInstance.stopListening(pageNavigationMiddlewareOptions);
    }
};
const resumePageNavigationMiddleware = () => {
    if (pageNavigationMiddlewareInstance) {
        pageNavigationMiddlewareInstance.startListening(pageNavigationMiddlewareOptions);
    }
};
export const pageNavigationMiddleware = {
    add: addPageNavigationMiddleware,
    pause: pausePageNavigationMiddleware,
    resume: resumePageNavigationMiddleware,
};
//# sourceMappingURL=pageNavigationMiddleware.js.map